import { render } from "./Qianming.vue?vue&type=template&id=9aba3228&scoped=true"
import script from "./Qianming.vue?vue&type=script&lang=js"
export * from "./Qianming.vue?vue&type=script&lang=js"

import "./Qianming.vue?vue&type=style&index=0&id=9aba3228&scoped=true&lang=css"

import exportComponent from "D:\\VSCODE_POJECT\\back-to-class-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aba3228"]])

export default __exports__